// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Third Party Components
import Cookies from "js-cookie";

// ** Config
import configGlobal from "configuration";

// ** Helpers
import { updateViewTypeCookie } from "helpers/updateViewTypeCookie";

// ############################################################

// Initial state
const initialState = {
	sharedGalleryViewType: "grid",
	homepageViewType: "list",
	usersListViewType: "list",
	initialized: false,
};

// ############################################################

// Slice
const globalViewTypesSlice = createSlice({
	name: "global/viewTypes",
	initialState,
	reducers: {
		setSharedGalleryViewType: (state, action) => {
			state.sharedGalleryViewType = action.payload;
			updateViewTypeCookie("sharedGalleryViewType", action.payload);
		},
		setHomepageViewType: (state, action) => {
			state.homepageViewType = action.payload;
			updateViewTypeCookie("homepageViewType", action.payload);
		},
		setUsersListViewType: (state, action) => {
			state.usersListViewType = action.payload;
			updateViewTypeCookie("usersListViewType", action.payload);
		},
		initializeViewTypesFromCookies: (state) => {
			if (!state.initialized) {
				try {
					const { cookieName } = configGlobal.viewTypes;
					let viewTypes = {};

					const savedCookies = Cookies.get(cookieName);
					if (savedCookies) {
						viewTypes = JSON.parse(savedCookies);
					}

					// ** Removed from localStorage.
					if (typeof window !== "undefined" && window.localStorage) {
						const reduxLocalStorage =
							localStorage.getItem("reduxLocalStorage");

						const localStorageValue =
							localStorage.getItem("usersListViewType");

						if (reduxLocalStorage) {
							try {
								const parsedReduxStorage =
									JSON.parse(reduxLocalStorage);
								const reduxViewTypes =
									parsedReduxStorage?.globalViewTypes;

								if (reduxViewTypes) {
									delete parsedReduxStorage.globalViewTypes;
									localStorage.setItem(
										"reduxLocalStorage",
										JSON.stringify(parsedReduxStorage),
									);
								}
							} catch (error) {
								// ** Intentionally ignored: non-critical failure.
							}
						}

						if (localStorageValue) {
							localStorage.removeItem("usersListViewType");
						}
					}

					// ** Apply values to Redux state.
					if (viewTypes.sharedGalleryViewType) {
						state.sharedGalleryViewType =
							viewTypes.sharedGalleryViewType;
					}
					if (viewTypes.homepageViewType) {
						state.homepageViewType = viewTypes.homepageViewType;
					}
					if (viewTypes.usersListViewType) {
						state.usersListViewType = viewTypes.usersListViewType;
					}
				} catch (error) {
					// ** Intentionally ignored: non-critical failure.
				}

				state.initialized = true;
			}
		},
	},
});

// ############################################################

export default globalViewTypesSlice.reducer;

// ** Actions
export const {
	setSharedGalleryViewType,
	setHomepageViewType,
	setUsersListViewType,
	initializeViewTypesFromCookies,
} = globalViewTypesSlice.actions;

// ############################################################
